import { render } from "./Annotate.vue?vue&type=template&id=9b3b7624&scoped=true"
import script from "./Annotate.vue?vue&type=script&lang=js"
export * from "./Annotate.vue?vue&type=script&lang=js"

import "./Annotate.vue?vue&type=style&index=0&id=9b3b7624&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b3b7624"]])

export default __exports__